import { injectable } from 'inversify';

import { WidgetTopNewsItem } from '@app/gen/dashboard';

import { WidgetTopNews } from '../types';

const MAX_NEWS_COUNT_TYPE_1_4 = 5;
const MAX_NEWS_COUNT_TYPE_4 = 4;

@injectable()
export class TopNewsMapper {
  processTopNewsItems(topNews: WidgetTopNewsItem[]) {
    return topNews.reduce<WidgetTopNews[]>((acc, item) => {
      const widget = item.widget;
      if (!widget) return acc;

      if (!widget.type || !widget.news || widget.news.length === 0) return acc;

      const hasName = !!item.account_name || !!item.company_name;
      if (!hasName) return acc;

      const requiredCount =
        widget.type === 'type_1_4'
          ? MAX_NEWS_COUNT_TYPE_1_4
          : MAX_NEWS_COUNT_TYPE_4;

      if (widget.news.length < requiredCount) return acc;

      const trimmedNews = widget.news.slice(0, requiredCount).map((n) => ({
        id: n.id,
        title: n.title,
        announcement: n.announcement,
        coverId: n.cover_att_id,
        category: n.category,
        publishedAt: n.published_at,
        isImportant: n.is_important,
      }));

      acc.push({
        companyId: item.company_id,
        companyName: item.company_name,
        accountId: item.account_id,
        accountName: item.account_name,
        widget: {
          type: widget.type,
          news: trimmedNews,
        },
      });

      return acc;
    }, []);
  }
}
